import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { QMManual } from './qmmanual';
import { ImageFile } from './imageFile';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';


export class QMManualLink extends StarbaseEntity implements Serializable<QMManualLink> {
    public qM_ManualModelUID: number;
    public imageModelUID: number;
    public qM_ManualModel: QMManual;
    public imageModel: ImageFile;

    constructor() {
        super();
    }

  public static setupUnitLinkCollection(collection: QMManualLink[]): void {
    if (!collection || !collection.length) { return; }
    of(collection).pipe(
      map((u: QMManualLink[]) =>
        u.map(
          (k: QMManualLink) => {
            k.imageModel ? new ImageFile().deserialize(k.imageModel) : k.imageModel = null;
            k.qM_ManualModel ? new QMManual().deserialize(k.qM_ManualModel) : k.qM_ManualModel = null;
          }))).subscribe();
  }

    deserialize(input) {
        return Object.assign(new QMManual(), input);
    }
}
